import React from "react";
import { DataHistoryLastWarehouseUpdate } from "../DataHistoryLastWarehouseUpdate/DataHistoryLastWarehouseUpdate";

export function StockLevelLastWarehouseUpdate(props) {
	const dataHistory = props.dataHistory;
	if (!dataHistory || dataHistory.length === 0) {
		return null;
	}

	const warehouseId = props.warehouseId;
	if (!warehouseId) {
		return null;
	}
	const targetSource = `stock-level-syncer_${warehouseId}`;

	const filteredDataHistory = dataHistory.filter((dhe) =>
		dhe.source === targetSource
	);
	return <DataHistoryLastWarehouseUpdate dataHistory={filteredDataHistory} />;
}